import { gql } from '@apollo/client';

export const COUPON_CODE_FIELDS_FRAGMENT = gql`
  fragment CouponCodeFields on CouponCode {
    id
    objectId: id
    createdAt
    updatedAt
    code
    brandName
    sentCount
    maxSends
    isActive
    hasSendsLeft
    generatedAt
    expiresAt
    couponCodeTypeId
  }
`;
